import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    collapseLabel: (resourceType: string) => string | React.ReactNode;
    emoji: string;
    groupMembersCount: (count: number) => string | React.ReactNode;
    labelAuthedUser: string;
    workspaceMemberCount: (count?: number) => string | React.ReactNode;
    accountMemberCount: (count?: number) => string | React.ReactNode;
    pending: string;
    resourceUserLabel: (memberName: string, roleName: string) => string | React.ReactNode;
    searchResultCount: (count: number) => string | React.ReactNode;
    resourceRedirectLabel: (resourceName: string) => string | React.ReactNode;
};
export type Deps = {
    Math: any;
};
export default {
    DEFINE(_messages: Text, { Math }: Deps): void {
        return Object.defineProperties(this, {
            /** Label for the button to show/hide a resource members list */
            collapseLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (resourceType: string) => __intl__.intl().formatMessage({ id: "InviteAccessResource.collapseLabel?c=6f9qp7sjfnpv", defaultMessage: "Show {var} Members" }, { var: resourceType.toLowerCase() }));
                },
                enumerable: true,
                configurable: true
            },
            /** Accessibility text for emoji icon */
            emoji: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "InviteAccessResource.emoji?c=3blfr39u4hcib", defaultMessage: "Emoji" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Text showing count of group members with pluralization */
            groupMembersCount: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (count: number) => __intl__.intl().formatMessage({ id: "InviteAccessResource.groupMembersCount?c=ab8arajxnkwq", defaultMessage: "{count, plural, one {1 Group Member} other {{count} Group Members}}" }, { count: count }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label indicating current authenticated user */
            labelAuthedUser: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "InviteAccessResource.labelAuthedUser?c=33hg9nvaytt5x", defaultMessage: "(you)" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Text showing member count for workspaces */
            workspaceMemberCount: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (count: number = 0) => { return __intl__.intl().formatMessage({ id: "InviteAccessResource.workspaceMemberCount.0?c=io2fj9j00v6z", defaultMessage: "{count, plural, one {1 parent Workspace Member} other {{count} parent Workspace Members}}" }, { count: count }); });
                },
                enumerable: true,
                configurable: true
            },
            /** Text showing member count for accounts */
            accountMemberCount: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (count: number = 0) => { const contentAdminCount = Math.max(count - 1, 0); return __intl__.intl().formatMessage({ id: "InviteAccessResource.accountMemberCount.0?c=2yuyzfhkxctti", defaultMessage: "{contentAdminCount, plural, one {Owner & 1 Content Admin} other {Owner & {contentAdminCount} Content Admins}}" }, { contentAdminCount: contentAdminCount }); });
                },
                enumerable: true,
                configurable: true
            },
            /** Label for pending (not yet accepted invite) user */
            pending: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "InviteAccessResource.pending?c=1hdx1m8rhv786", defaultMessage: "Pending User" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label showing member name and role for resource access */
            resourceUserLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (memberName: string, roleName: string) => __intl__.intl().formatMessage({ id: "InviteAccessResource.resourceUserLabel?c=2pi4wx8yr1vn5", defaultMessage: "{memberName} has access via this resource \u2022 {roleName}" }, { memberName: memberName, roleName: roleName }));
                },
                enumerable: true,
                configurable: true
            },
            /** Text showing search result count with mixed roles */
            searchResultCount: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (count: number) => __intl__.intl().formatMessage({ id: "InviteAccessResource.searchResultCount?c=ocolyqwy4zvt", defaultMessage: "{count} Matches have access via this resource \u2022 Mixed roles" }, { count: count }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for button to redirect to resource member management */
            resourceRedirectLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (resourceName: string) => __intl__.intl().formatMessage({ id: "InviteAccessResource.resourceRedirectLabel?c=1u8cypwig0rp8", defaultMessage: "Manage members from {resourceName}" }, { resourceName: resourceName }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps: Deps): void;
};
